'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .cropper-view-box {\n    outline-color: ", "!important;\n  }\n  .submenu-item-name {\n    text-transform: capitalize;\n\n  }\n\n  .ant-table-body::-webkit-scrollbar-track  {\n    background-color: ", " !important;\n  }\n\n  .ant-table-body::-webkit-scrollbar-thumb {\n    background-color: ", " !important;\n\n  }\n\n  .ant-calendar-picker-container {\n    color: ", ";\n  }\n  .ant-calendar-header .ant-calendar-century-select, .ant-calendar-header ,\n  .ant-calendar-decade-select, .ant-calendar-header .ant-calendar-year-select, \n  .ant-calendar-header .ant-calendar-month-select {\n    color: ", ";\n\n  }\n\n  .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {\n    color: ", " !important;;\n  }\n\n  .ant-collapse > .ant-collapse-item > .ant-collapse-header {\n    color: ", " !important;\n\n  }\n\n  h1, h2, h3, h4, h5, h6 {\n    color: ", " !important;\n\n  }\n\n  .ant-calendar-header .ant-calendar-prev-century-btn, .ant-calendar-header ,\n  .ant-calendar-next-century-btn, .ant-calendar-header .ant-calendar-prev-decade-btn, \n  .ant-calendar-header .ant-calendar-next-decade-btn, .ant-calendar-header ,\n  .ant-calendar-prev-month-btn, .ant-calendar-header .ant-calendar-next-month-btn,\n  .ant-calendar-header .ant-calendar-prev-year-btn, .ant-calendar-header .ant-calendar-next-year-btn {\n\n    color: ", " !important;\n    \n  }\n\n  .ant-input {\n    color: ", " !important;\n  }\n\n  .ant-select-dropdown {\n    background-color: ", ";\n    border: ", ";\n  }\n\n  .ant-select-dropdown .ant-select-dropdown-menu-item-active {\n    background-color: ", " !important;\n  }\n\n  .ant-select-dropdown .ant-select-dropdown-menu-item-selected {\n    background-color: ", " !important;\n\n  }\n  .ant-select-dropdown-menu-item {\n    color: ", "; ;\n  }\n\n  .ant-checkbox-wrapper {\n    color: ", " !important;\n    \n  }\n\n  .pdf-preview-container {\n    background-color: ", " !important;\n  }\n\n  .media-uploader {\n    background-color: ", ";\n  }\n  \n  .ant-form {\n    color: ", " !important;\n\n  }\n\n  .ant-form-item {\n    color: ", " !important;\n\n  }\n  .ant-select {\n    color: ", " !important;\n  }\n\n    .ant-pagination * {\n    color: ", ";\n  }\n\n  .ant-pagination .ant-pagination-item-active a {\n    color: ", ";\n  }\n\n  .ant-layout-sider .ant-menu-submenu .ant-menu-item {\n    text-transform: capitalize;\n  }\n\n  .ant-form-item-label label {\n    color: ", " !important;\n  }\n\n  .ant-tabs-bar {\n    border-bottom: ", " !important;\n  }\n\n  .ant-btn:not(.ant-btn-primary):not([disabled]) {\n    color: ", ";\n  }\n  \n  .ant-btn:not(.ant-btn-primary):not([disabled]):hover {\n   color: ", ";\n  }\n\n  .ant-dropdown-menu.ant-dropdown-menu {\n  background: ", ";\n  \n  }\n\n  .ant-dropdown-menu-item {\n    color: ", ";\n  }\n\n  .ant-dropdown-menu-item:hover {\n    background-color:  ", " ;\n\n  }\n\n    .ant-pagination {\n    background-color: ", ";\n    border-color: ", ";\n  }\n  .ant-pagination .ant-pagination-item-active {\n    background-color: ", " !important;\n  }\n\n  .ant-pagination .ant-pagination-item:hover {\n    background-color: ", " !important;\n\n    a {\n      color: #D3D4D9 !important;\n    }\n  }\n\n  .ant-card.ant-card-bordered {\n    border-bottom: ", " !important;;\n  }\n\n  .ant-calendar-selected-date:not(.ant-calendar-disabled-cell) {\n    div {\n      background: ", "!important;\n      color: #fff!important;\n    }\n  }\n  .ant-layout-content {\n    background-color: ", ";\n  }\n  .cropper-line, .cropper-point {\n    background-color: ", "!important;\n  }\n\n  .ant-calendar-decade-panel-selected-cell {\n    .ant-calendar-decade-panel-decade, .ant-calendar-decade-panel-decade:hover {\n      background-color: ", ";\n    }\n  }\n\n  .ant-calendar-decade-panel-cell:not(.ant-calendar-decade-panel-selected-cell) {\n    .ant-calendar-decade-panel-decade:hover {\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  .ant-calendar-year-panel-selected-cell {\n    a {\n      background-color: ", "!important;\n    }\n  }\n  .ant-calendar-year-panel-decade-select, \n  .ant-calendar-decade-panel-prev-century-btn,\n  .ant-calendar-decade-panel-next-century-btn,\n  .ant-calendar-year-panel-next-decade-btn,\n  .ant-calendar-year-panel-prev-decade-btn {\n    &:hover {\n      color: ", "!important;\n    }\n  }\n  .ant-calendar-month-panel-header a:hover {\n    color: ", ";\n  }\n\n  .ant-table-placeholder {\n    background-color: ", " !important;\n    border-color: ", " !important;\n    color:  ", " !important;\n  }\n\n  .ant-calendar-month-panel-prev-year-btn, \n  .ant-calendar-month-panel-next-year-btn, \n  .ant-calendar-month-panel-year-select-content,\n  .ant-calendar-prev-year-btn,\n  .ant-calendar-next-year-btn, \n  .ant-calendar-prev-month-btn, \n  .ant-calendar-next-month-btn {\n    &:hover {\n      color: ", "!important;\n      outline-color: ", "!important;\n    }\n  }\n\n  .ant-calendar-my-select, .ant-calendar-year-panel-cell {\n    a:hover  {\n      color: ", ";\n    } \n  }\n\n  .ant-calendar-month-panel-cell:not(.ant-calendar-month-panel-selected-cell) {\n    &:hover {\n      .ant-calendar-month-panel-month {\n        color: ", ";\n      }\n    }\n  }\n\n  .ant-calendar-month-panel-selected-cell:not(.ant-calendar-disabled-cell) {\n    .ant-calendar-month-panel-month {\n      background-color: ", ";\n    }\n  }\n  .ant-calendar-selected-date:not(.ant-calendar-disabled-cell) div {\n    background-color: ", " !important;\n    \n  }\n\n  .ant-calendar-cell.ant-calendar-today:not(.ant-calendar-selected-day):not(.ant-calendar-disabled-cell) .ant-calendar-date {\n    color: ", " !important;\n  }\n\n  .ant-calendar .ant-calendar-input-wrap {\n    border-bottom-color: ", ";\n\n  }\n\n  .ant-calendar-input {\n    color: ", ";\n\n  }\n\n  .ant-calendar-my-select a:hover, .ant-calendar-year-panel-cell a:hover {\n    color: ", ";\n  ;\n  }\n\n  .ant-calendar .ant-calendar-header {\n    border-bottom-color: ", ";\n  }\n\n  .ant-calendar .ant-calendar-disabled-cell .ant-calendar-date {\n    background-color: ", ";\n  }\n  \n  .ant-calendar {\n    background-color: ", ";\n    border: ", ";\n  }\n\n  .ant-calendar-date:hover {\n    background-color:  ", ";;\n  }\n\n  .ant-calendar-cell {\n    .ant-calendar-date:active {\n      background-color: ", ";\n    }\n\n    &.ant-calendar-selected-day:not(.ant-calendar-disabled-cell) {\n      div {\n        border-color: ", ";\n        color: #fff!important;\n      }\n      .ant-calendar-date {\n        background-color: ", ";\n      }\n    }\n\n    &.ant-calendar-today:not(.ant-calendar-selected-day):not(.ant-calendar-disabled-cell) {\n      .ant-calendar-date {\n        border-color: ", ";\n        color: ", ";\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _theme = require('shared/styled/theme');

var _theme2 = _interopRequireDefault(_theme);

var _colors = require('shared/styled/colors');

var _colors2 = _interopRequireDefault(_colors);

var _themes = require('shared/constants/themes');

var _themes2 = _interopRequireDefault(_themes);

var _isSp = require('../../utils/isSp');

var _styledComponents = require('styled-components');

var _firstLoadUnAuthAction = require('../../actions/firstLoadUnAuthAction');

var _spPlatformConfigActions = require('../../actions/spPlatformConfigActions');

var _userDataActions = require('../../actions/userDataActions');

var _pushNotificationsActions = require('../../actions/pushNotificationsActions');

var _platforms = require('../../constants/platforms');

var _platforms2 = _interopRequireDefault(_platforms);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var GlobalStyle = _styledComponents.createGlobalStyle(_templateObject(), function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.spPlatformConfig ? "transparent" : '';
}, function (props) {
  return props.spPlatformConfig ? _colors2.default.gray.sp300 : '';
}, (0, _isSp.isSp)() ? 'white' : '', (0, _isSp.isSp)() ? 'white' : '', function (props) {
  return props.spPlatformConfig ? "white" : '';
}, function (props) {
  return props.spPlatformConfig ? props.theme.spText : '';
}, function (props) {
  return props.spPlatformConfig ? props.theme.spText : '';
}, function (props) {
  return props.spPlatformConfig && 'white';
}, function (props) {
  return props.spPlatformConfig && props.theme.spText;
}, function (props) {
  return props.spPlatformConfig && props.theme.platformPrimary;
}, function (props) {
  return props.spPlatformConfig && "1px solid ".concat(props.theme.spDarker);
}, function (props) {
  return props.spPlatformConfig && props.theme.spDarker;
}, function (props) {
  return props.spPlatformConfig && props.theme.spDarker;
}, function (props) {
  return props.spPlatformConfig && 'white !important';
}, function (props) {
  return props.spPlatformConfig && props.theme.spText;
}, function (props) {
  return props.spPlatformConfig ? _colors2.default.gray.sp100 : '';
}, function (props) {
  return props.spPlatformConfig && 'transparent !important';
}, function (props) {
  return props.spPlatformConfig && props.theme.spText;
}, function (props) {
  return props.spPlatformConfig && props.theme.spText;
}, function (props) {
  return props.spPlatformConfig && props.theme.spText;
}, function (props) {
  return props.spPlatformConfig ? 'white !important' : "";
}, function (props) {
  return props.spPlatformConfig ? 'white !important' : '';
}, function (props) {
  return props.spPlatformConfig && props.theme.spText;
}, function (props) {
  return props.spPlatformConfig && "1px solid ".concat(props.theme.spBorder);
}, function (props) {
  return props.spPlatformConfig ? "".concat(props.theme.platformPrimary) : '';
}, function (props) {
  return props.spPlatformConfig ? "white !important" : '';
}, function (props) {
  return (0, _isSp.isSp)() ? "white !important" : '';
}, function (props) {
  return (0, _isSp.isSp)() ? "black !important" : '';
}, function (props) {
  return (0, _isSp.isSp)() && "".concat(props.theme.spSecondaryLight, " !important");
}, function (props) {
  return props.spPlatformConfig && props.spPlatformConfig.accentColor;
}, function (props) {
  return props.spPlatformConfig && props.theme.spSecondary;
}, function (props) {
  return props.spPlatformConfig && props.theme.spSecondary;
}, function (props) {
  return props.spPlatformConfig && props.theme.spDarker;
}, function (props) {
  return props.spPlatformConfig && 'unset';
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.spPlatformConfig && 'white';
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.spPlatformConfig && _colors2.default.gray.sp100;
}, function (props) {
  return props.spPlatformConfig && props.theme.spBorder;
}, function (props) {
  return props.spPlatformConfig && props.theme.spText;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.spPlatformConfig && props.theme.spSecondary;
}, function (props) {
  return props.spPlatformConfig && 'white';
}, function (props) {
  return props.spPlatformConfig && props.theme.spDarker;
}, (0, _isSp.isSp)() ? 'white' : '', function (props) {
  return props.spPlatformConfig && '#bcbcbc';
}, function (props) {
  return props.spPlatformConfig && props.theme.spDarker;
}, function (props) {
  return props.spPlatformConfig && props.theme.spLighter;
}, function (props) {
  return props.spPlatformConfig && props.theme.platformPrimary;
}, function (props) {
  return props.spPlatformConfig && "1px solid ".concat(props.theme.spDarker);
}, function (props) {
  return props.spPlatformConfig && props.theme.spSecondary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
});

var App =
/*#__PURE__*/
function (_react$Component) {
  _inherits(App, _react$Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _getPrototypeOf(App).apply(this, arguments));
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var accessToken = sessionStorage.getItem('access_token');

      if (this.props.platform !== _platforms2.default.ADMIN) {
        this.props.getPlatformDetails();
      }

      if (accessToken) {
        this.props.fetchUserInformation();
        this.props.pushNotificationsConnect();
        this.props.getDealManagementEnabled();
      }
    }
  }, {
    key: "isPlatformDataFetching",
    value: function isPlatformDataFetching() {
      var _this$props = this.props,
          detailsFetched = _this$props.detailsFetched,
          exists = _this$props.exists,
          spFetched = _this$props.spFetched;
      return !detailsFetched || detailsFetched && exists && !spFetched;
    }
  }, {
    key: "render",
    value: function render() {
      var defaultTheme = _extends({}, _theme2.default, {
        platformPrimary: this.props.theme === _themes2.default.WHITE ? _colors2.default.blue.base : _colors2.default.blue.light,
        name: this.props.theme
      });

      if (this.props.platform === _platforms2.default.ADMIN) {
        return _react2.default.createElement(_styledComponents.ThemeProvider, {
          theme: _extends({}, defaultTheme, {
            platformPrimary: _colors2.default.blue.base
          })
        }, this.props.children);
      }

      var _this$props2 = this.props,
          spPlatformConfig = _this$props2.spPlatformConfig,
          detailsFetched = _this$props2.detailsFetched,
          exists = _this$props2.exists,
          spFetched = _this$props2.spFetched;
      var theme = spPlatformConfig && spPlatformConfig.accentColor && spPlatformConfig.hoverColor ? _extends({}, defaultTheme, {
        platformPrimary: spPlatformConfig.accentColor,
        spSecondary: "color-mix(in srgb, ".concat(spPlatformConfig.accentColor, " 80%, black)"),
        spSecondaryLight: "color-mix(in srgb, ".concat(spPlatformConfig.accentColor, " 70%, white)"),
        spDarker: "color-mix(in srgb, ".concat(spPlatformConfig.accentColor, " 60%, black)"),
        spLighter: "color-mix(in srgb, ".concat(spPlatformConfig.accentColor, " 80%, white)")
      }) : defaultTheme;
      return _react2.default.createElement(_styledComponents.ThemeProvider, {
        theme: theme
      }, _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(GlobalStyle, {
        spPlatformConfig: spPlatformConfig
      }), !this.isPlatformDataFetching() && this.props.children));
    }
  }]);

  return App;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var theme = state.user.info.theme;

  if (ownProps.platform !== _platforms2.default.ADMIN) {
    var _state$spPlatform = state.spPlatform,
        spPlatformConfig = _state$spPlatform.config,
        spFetched = _state$spPlatform.fetched,
        _state$user$strategic = state.user.strategicPartners,
        detailsFetched = _state$user$strategic.detailsFetched,
        exists = _state$user$strategic.exists;
    return {
      theme: theme,
      spPlatformConfig: spPlatformConfig,
      spFetched: spFetched,
      detailsFetched: detailsFetched,
      exists: exists
    };
  }

  return {
    theme: theme
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getPlatformDetails: function getPlatformDetails() {
      return dispatch((0, _firstLoadUnAuthAction.getPlatformDetails)());
    },
    fetchUserInformation: function fetchUserInformation() {
      return dispatch((0, _userDataActions.fetchUserInformation)());
    },
    pushNotificationsConnect: function pushNotificationsConnect() {
      return dispatch((0, _pushNotificationsActions.pushNotificationsConnectAction)());
    },
    getDealManagementEnabled: function getDealManagementEnabled() {
      return dispatch((0, _spPlatformConfigActions.getDealManagementEnabled)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);